'use client';
import React, { useEffect } from 'react';

export interface QuizLeaderBoardProps {
  form_factor?: string;
  series_id?: string;
  tournament?: boolean;
}

export const QuizLeaderBoard: React.FC<QuizLeaderBoardProps> = ({
  form_factor = 'desktop',
  series_id = '',
  tournament = false,
}) => {
  const partner_id = 'ChihKCDRc5E7vh2O66g3';
  useEffect(() => {
    const scriptSrc = 'https://client.riverdrop.com/dist/leaderboard/assets/index.js';
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      script.type = 'module';
      document.head.appendChild(script);
      script.onload = () => {
        window.dispatchEvent(new Event('riverdrop-quiz-init'));
      };
    } else {
      // If script is already loaded, dispatch the event
      window.dispatchEvent(new Event('riverdrop-quiz-init'));
    }
  }, []);

  if (series_id === '') {
    return null;
  }
  return (
    <div className="block">
      {React.createElement('riverdrop-leaderboard', {
        authtype: 'benzinga_before',
        formfactor: form_factor,
        maxvisible: 10,
        outerpadding: '25px',
        partnerid: partner_id,
        quantity: 20,
        seriesid: series_id,
        tournament: tournament ? 'true' : 'false',
      })}
    </div>
  );
};
